<template>
    <div class="page-wrap">
        <!-- 顶部返回栏 -->
        <div class="header-back">
            <a class="back-btn" @click="backFun">
                <svg class="back-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
                </svg>
                <span class="back-text">{{ $t('返回') }}</span>
            </a>
        </div>

        <!-- 主内容区域 -->
        <div class="main-content">
            <h1 class="page-title">{{ $t('基础身份认证') }}</h1>

            <!-- 步骤1：填写信息 -->
            <div v-if="step === 1">
                <div class="auth-title-row">
                    <div class="check-circle">
                        1
                    </div>
                    <div class="title-text-wrap">
                        <p class="main-title">{{ $t('实名认证') }}</p>
                    </div>
                </div>
                <div class="form-wrap">
                    <!-- 国家/地区 -->
                    <p class="sub-desc">{{ $t('即可使完整服务') }}</p>
                    <div class="form-item">
                        <label class="form-label">{{ $t('国家或地区') }}</label>
                        <div class="input-box" style="justify-content: space-between;"
                            @click.stop="countryShow = !countryShow">
                            <a class="text-phone">
                                {{ form.area_code }} {{ area_text }}
                            </a>
                            <div>
                                <i class="iconfont icon-xiajiantou"></i>
                            </div>
                        </div>

                        <div class="item_box" v-if="countryShow">
                            <div class="search-box">
                                <input type="text" v-model="searchCode" :placeholder="$t('搜索区号')"
                                    @input="inputFun"></input>
                            </div>
                            <a v-for="(item, index) in countrys" :key="index"
                                :class="{ 'active': item.code === form.area_code }" @click.stop="onSelect(item)">
                                {{ item.code }} {{ item.text }}
                            </a>
                        </div>
                    </div>

                    <!-- 证件类型单选 -->
                    <div class="form-item">
                        <label class="form-label">{{ $t('证件类型') }}</label>
                        <div class="radio-group">
                            <label class="radio-item" @click="form.certificate_type = 0">
                                <div class="quan" :class="{ 'active': form.certificate_type === 0 }">
                                    <i class="iconfont icon-duihao"></i>
                                </div>
                                <span>{{ $t('身份证') }}</span>
                            </label>
                            <label class="radio-item" @click="form.certificate_type = 1">
                                <div class="quan" :class="{ 'active': form.certificate_type === 1 }">
                                    <i class="iconfont icon-duihao"></i>
                                </div>
                                <span>{{ $t('驾照') }}</span>
                            </label>
                            <label class="radio-item" @click="form.certificate_type = 2">
                                <div class="quan" :class="{ 'active': form.certificate_type === 2 }">
                                    <i class="iconfont icon-duihao"></i>
                                </div>
                                <span>{{ $t('护照') }}</span>
                            </label>
                            <label class="radio-item" @click="form.certificate_type = 3">
                                <div class="quan" :class="{ 'active': form.certificate_type === 3 }">
                                    <i class="iconfont icon-duihao"></i>
                                </div>
                                <span>{{ $t('其他合法证件') }}</span>
                            </label>
                        </div>
                    </div>

                    <!-- 姓 -->
                    <div class="form-item">
                        <label class="form-label">{{ $t("xing") }}</label>
                        <div class="input-box">
                            <input v-model="form.last_name" class="inner-input" :placeholder="$t('qsrxing')" />
                            <div v-if="form.last_name" @click="form.last_name = ''" class="clear-btn">
                                <svg class="close-icon" fill="#666" viewBox="0 0 20 20">
                                    <path
                                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z">
                                    </path>
                                </svg>
                            </div>
                        </div>
                    </div>

                    <!-- 名 -->
                    <div class="form-item">
                        <label class="form-label">{{ $t("ming") }}</label>
                        <div class="input-box">
                            <input v-model="form.first_name" class="inner-input" :placeholder="$t('qsrming')" />
                            <div v-if="form.first_name" @click="form.first_name = ''" class="clear-btn">
                                <svg class="close-icon" fill="#666" viewBox="0 0 20 20">
                                    <path
                                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z">
                                    </path>
                                </svg>
                            </div>
                        </div>
                    </div>

                    <!-- 证件号码 -->
                    <div class="form-item">
                        <label class="form-label">{{ $t('证件号码') }}</label>
                        <div class="input-box">
                            <input v-model="form.certificate_number" class="inner-input" :placeholder="$t('请输入证件号码')" />
                            <div v-if="form.certificate_number" @click="form.certificate_number = ''" class="clear-btn">
                                <svg class="close-icon" fill="#666" viewBox="0 0 20 20">
                                    <path
                                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z">
                                    </path>
                                </svg>
                            </div>
                        </div>
                    </div>

                    <!-- 出生日期 -->
                    <div class="form-item">
                        <label class="form-label">{{ $t('csrq') }}</label>
                        <div class="select-box" :class="{'select-date':form.birth_date === ''}">
                            <van-cell :value="form.birth_date?form.birth_date:$t('qsrcsrq')" @click="dateShow = true" >
                                <template #right-icon>
                                    <i class="iconfont icon-rili" style="margin-left: 6px;"></i>
                                </template>
                            </van-cell>

                            <!-- <span class="select-placeholder" :class="{ 'select-text': form.birth_date !== '' }">{{
                                form.birth_date || $t('qsrcsrq') }}</span>
                            <input v-model="form.birth_date" type="date" :placeholder="$t('qsrcsrq')"
                                class="date-input" />
                            <div
                                style="margin-left: auto;width: 20px;height: 20px;display: flex;align-items: center;justify-content: center;">
                                <i class="iconfont icon-rili"></i> </div> -->
                        </div>
                    </div>

                    <!-- 提示文字 -->
                    <div class="tip-text">
                        <p>1.{{ $t('认证信息一经验证') }}</p>
                        <p>2.{{ $t('被认证的实名信息不能重复认证') }}</p>
                    </div>

                    <!-- 下一步按钮 -->
                    <button @click="nextStep" :class="['next-btn', isFormComplete ? 'btn-active' : 'btn-disabled']">
                        {{ $t('invest.next') }}
                    </button>
                </div>

                <div class="step-title-row">
                    <span class="step-num gray-step-num">2</span>
                    <p class="step-main-title" style="color: #999;">{{ $t('上传证件照') }}</p>
                </div>
                <div class="form-wrap" style="height: 20px;"></div>
                <div class="step-title-row">
                    <span class="step-num gray-step-num">3</span>
                    <p class="step-main-title" style="color: #999;">{{ $t('提交审核') }}</p>
                </div>
            </div>

            <!-- 步骤2：上传证件照 -->
            <div v-if="step === 2">
                <div class="auth-title-row title-text-wrap">
                    <div class="check-circle" style="background: #000;">
                        <i class="iconfont icon-duigou_kuai" style="color: #fff;"></i>
                    </div>
                    <p class="main-title">{{ $t('实名认证') }}</p>
                </div>
                <!-- 展示填写信息（不可编辑） -->
                <div class="info-show-wrap" style="border-color: #333;">
                    <p class="info-line"><span style="color: #000;font-weight: bold;">{{ form.last_name }} {{
                        form.first_name }}</span></p>
                    <p class="info-line">{{ $t('国家或地区') }} <span style="color: #000;">{{ form.area_code }} {{ area_text
                    }}</span></p>
                    <p class="info-line">{{ $t('证件类型') }} <span style="color: #000;">{{
                        getIdCradName(form.certificate_type) }}</span></p>
                    <p class="info-line">{{ $t('证件号码') }} <span style="color: #000;">{{ form.certificate_number
                            }}</span>
                    </p>
                </div>

                <div class="step-title-row">
                    <span class="step-num gray-step-num">2</span>
                    <p class="step-main-title">{{ $t('上传证件照') }}</p>
                </div>

                <div class="info-show-wrap">
                    <div class="upload-rule-text">
                        <p>1.{{ $t('请上传所有照片') }}</p>
                        <p>2.{{ $t('所有上传的照片必须清晰可见') }}</p>
                    </div>

                    <!-- 证件封面上传 -->
                    <div class="upload-card">
                        <div class="upload-label-row">
                            <span class="upload-label">{{ $t('证件封面') }}</span>
                            <svg class="tip-icon" fill="none" stroke="#999" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                            </svg>
                        </div>
                        <div class="upload-box">
                            <van-uploader v-model="fileList1" multiple preview-size="200" :max-count="1"
                                :after-read="afterRead">
                                <div class="upload-empty">
                                    <svg class="upload-empty-icon" fill="none" stroke="#ddd" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                                            d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z">
                                        </path>
                                    </svg>
                                    <span class="upload-blue-text">{{ $t('上传证件封面') }}</span>
                                </div>
                            </van-uploader>
                        </div>
                    </div>

                    <!-- 证件个人信息页上传 -->
                    <div class="upload-card">
                        <div class="upload-label-row">
                            <span class="upload-label">{{ $t('证件个人信息页') }}</span>
                            <svg class="tip-icon" fill="none" stroke="#999" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                            </svg>
                        </div>
                        <div class="upload-box">
                            <van-uploader v-model="fileList2" multiple preview-size="200" :max-count="1"
                                :after-read="afterRead2">
                                <div class="upload-empty">
                                    <svg class="upload-empty-icon" fill="none" stroke="#ddd" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                                            d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z">
                                        </path>
                                    </svg>
                                    <span class="upload-blue-text">{{ $t('上传证件封面') }}</span>
                                </div>
                            </van-uploader>
                        </div>
                    </div>
                    <button @click="nextStep"
                        :class="['submit-btn', form.certificate_cover && form.personal_info_page ? 'btn-blue-active' : 'btn-disabled']">
                        {{ $t('invest.next') }}
                    </button>
                </div>
                <div class="step-title-row">
                    <span class="step-num gray-step-num">3</span>
                    <p class="step-main-title" style="color: #999;">{{ $t('提交审核') }}</p>
                </div>
            </div>

            <!-- 步骤3：最终提交审核预览 -->
            <div v-if="step >= 3">
                <div class="auth-title-row title-text-wrap">
                    <div class="check-circle" style="background: #000;">
                        <i class="iconfont icon-duigou_kuai" style="color: #fff;"></i>
                    </div>
                    <p class="main-title">{{ $t('实名认证') }}</p>
                </div>
                <!-- 展示填写信息（不可编辑） -->
                <div class="info-show-wrap" style="border-color: #333;">
                    <p class="info-line"><span style="color: #000;font-weight: bold;">{{ form.last_name }} {{
                        form.first_name }}</span></p>
                    <p class="info-line">{{ $t('国家或地区') }} <span style="color: #000;">{{ form.area_code }} {{ area_text
                    }}</span></p>
                    <p class="info-line">{{ $t('证件类型') }} <span style="color: #000;">{{
                        getIdCradName(form.certificate_type) }}</span></p>
                    <p class="info-line">{{ $t('证件号码') }} <span style="color: #000;">{{ form.certificate_number
                            }}</span>
                    </p>
                </div>

                <div class="step-title-row">
                    <div class="check-circle" style="background: #000;">
                        <i class="iconfont icon-duigou_kuai" style="color: #fff;"></i>
                    </div>
                    <p class="step-main-title">{{ $t('上传证件照') }}</p>
                </div>

                <div class="info-show-wrap">
                    <div class="upload-rule-text">
                        <p>1.{{ $t('请上传所有照片') }}</p>
                        <p>2.{{ $t('所有上传的照片必须清晰可见') }}</p>
                    </div>

                    <!-- 证件封面上传 -->
                    <div class="upload-card">
                        <div class="upload-label-row">
                            <span class="upload-label">{{ $t('证件封面') }}</span>
                            <svg class="tip-icon" fill="none" stroke="#999" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                            </svg>
                        </div>
                        <div class="upload-box">
                            <van-uploader v-model="fileList1" multiple preview-size="200" :max-count="1"
                                :after-read="afterRead">
                                <div class="upload-empty">
                                    <svg class="upload-empty-icon" fill="none" stroke="#ddd" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                                            d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z">
                                        </path>
                                    </svg>
                                    <span class="upload-blue-text">{{ $t('上传证件封面') }}</span>
                                </div>
                            </van-uploader>
                        </div>
                    </div>

                    <!-- 证件个人信息页上传 -->
                    <div class="upload-card">
                        <div class="upload-label-row">
                            <span class="upload-label">{{ $t('证件个人信息页') }}</span>
                            <svg class="tip-icon" fill="none" stroke="#999" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                            </svg>
                        </div>
                        <div class="upload-box">
                            <van-uploader v-model="fileList2" multiple preview-size="200" :max-count="1"
                                :after-read="afterRead2">
                                <div class="upload-empty">
                                    <svg class="upload-empty-icon" fill="none" stroke="#ddd" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                                            d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z">
                                        </path>
                                    </svg>
                                    <span class="upload-blue-text">{{ $t('上传证件封面') }}</span>
                                </div>
                            </van-uploader>
                        </div>
                    </div>
                    <button @click="nextStep" v-if="step < 3"
                        :class="['submit-btn', form.certificate_cover && form.personal_info_page ? 'btn-blue-active' : 'btn-disabled']">
                        {{ $t('提交审核') }}
                    </button>
                </div>
                <div class="step-title-row">
                    <span class="step-num gray-step-num" v-if="step === 3">3</span>
                    <div class="check-circle" style="background: #000;" v-if="step > 3">
                        <i class="iconfont icon-duigou_kuai" style="color: #fff;"></i>
                    </div>
                    <p class="step-main-title" style="color: #999;">{{ $t('提交审核') }}</p>
                </div>
                <button class="submit-btn btn-blue-active" @click="submitAuth"> {{ $t('提交审核') }}</button>
            </div>
        </div>
        <div style="height: 50px;"></div>
        <div style="width: 100%;height: fit-content;position: relative;position: fixed;bottom: 0;z-index: 999;background: #fff;max-width: 750px;left: 50%;transform: translateX(-50%);box-shadow: 0px -2px 10px #eee;"
            v-if="dateShow">
            <van-datetime-picker v-model="currentDate" type="date" :title="$t('qsrcsrq')" :min-date="minDate" :max-date="maxDate"
                :cancel-button-text="$t('utils.cancel')" :confirm-button-text="$t('utils.confirm')" @confirm="onConfirm"
                @cancel="dateShow = false" />
        </div>
    </div>
</template>

<script>
import Fetch from "../../utils/fetch"
import axios from 'axios'
import Api from "../../interface/index";
import { Toast, Icon } from 'vant'
export default {
    name: "RealNameAuth",
    created() {
        this.$parent.footer('idCardDetail', false);
        Fetch("/loan/countrys").then((r) => {
            this.countrys = r.data.map(x => {
                return { text: x.name, code: x.code }
            })
            this.countrys2 = r.data.map(x => {
                return { text: x.name, code: x.code }
            })
        });
    },
    data() {
        return {
            currentDate: new Date(),
            minDate: new Date(1926, 0, 1),
            maxDate: new Date(),
            countryShow: false,
            searchCode: '',
            dateShow: false,
            countrys: [],
            countrys2: [],
            area_text: '',
            btnStatus: false,
            step: 1,
            // 表单数据
            fileList1: [],
            fileList2: [],
            form: {
                area_code: localStorage.getItem('countryCode') || "+93",              //区号
                certificate_type: 0,        //证件类型
                last_name: "",              //用户姓氏
                first_name: "",             //用户名字
                certificate_number: "",     //证件号码
                birth_date: "",             //出生日期
                certificate_cover: "",       //证件封面
                personal_info_page: "",      //证件个人信息页，最大长度255
                rejection_reason: "",        //审核拒绝时候显示拒绝原因
                audit_time: ""               //审核时间
            },
            // 上传图片
            uploadData: {
                frontImg: "",
                backImg: ""
            },
            // 文件ref
            frontInput: null,
            backInput: null
        };
    },
    computed: {
        isFormComplete() {
            return this.form.last_name && this.form.first_name && this.form.certificate_number && this.form.birth_date;
        }
    },
    methods: {
        formatDate(date) {
            return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
        },
        onConfirm(date) {
            this.dateShow = false;
            this.form.birth_date = this.formatDate(date);
        },
        afterRead(e) {
            let that = this
            let formData = new FormData();
            this.$toast.loading({
                message: this.$t("upLoading"),
                forbidClick: true,
                duration: 0
            });
            formData.append('file', e.file);
            formData.append('language', this.$i18n.locale || "en_us");
            formData.append('token', localStorage.getItem('token'));
            axios.post(Api.commonUrl + "/api/index/upload_img", formData).then(res => {
                if (res.data.code === 0) {
                    that.$toast(res.data.info);
                    return
                }
                this.form.certificate_cover = res.data.data
                this.$toast.clear()
            })
        },
        afterRead2(e) {
            let that = this
            let formData = new FormData();
            this.$toast.loading({
                message: this.$t("upLoading"),
                forbidClick: true,
                duration: 0
            });
            formData.append('file', e.file);
            formData.append('language', this.$i18n.locale || "en_us");
            formData.append('token', localStorage.getItem('token'));
            axios.post(Api.commonUrl + "/api/index/upload_img", formData).then(res => {
                // console.log(res)
                if (res.data.code === 0) {
                    that.$toast(res.data.info);
                    return
                }
                this.form.personal_info_page = res.data.data
                this.$toast.clear()
            })
        },
        getIdCradName(type) {
            if (this.form.certificate_type === 0) {
                return this.$t('身份证')
            } else if (this.form.certificate_type === 1) {
                return this.$t('驾照')
            } else if (this.form.certificate_type === 2) {
                return this.$t('护照')
            } else if (this.form.certificate_type === 3) {
                return this.$t('其他合法证件')
            }
        },
        onSelect(action) {
            this.form.area_code = action.code
            this.area_text = action.text
            this.countryShow = false
        },
        inputFun() {
            // 如果输入框为空，恢复原始数据
            if (!this.searchCode) {
                this.countrys = [...this.countrys2];
                return;
            }

            // 筛选逻辑：匹配区号中的数字部分
            const searchValue = this.searchCode;
            this.countrys = this.countrys2.filter(item => {
                // 去除code中的+号，只保留数字进行匹配
                const codeNumber = item.code.replace('+', '');
                // 包含匹配（也可以改成开头匹配：codeNumber.startsWith(searchValue)）
                return codeNumber === searchValue;
            });
        },
        nextStep() {
            if (this.step === 1 && !this.isFormComplete) return;
            if (this.step === 2 && (!this.form.certificate_cover || !this.form.personal_info_page)) {
                // if(!this.form.certificate_cover) {
                //     this.$toast(this.$t('请上传证件封面'));
                // }
                // if(!this.form.personal_info_page) {
                //     this.$toast(this.$t('请上传证件个人信息页'));
                // }
                return;
            };
            this.step++;

        },
        removeImg(key) {
            this.form[key] = "";
        },
        submitAuth() {
            if (this.btnStatus) {
                return
            }
            this.btnStatus = true
            let data = this.form
            Fetch("/user/real_name", data).then((res) => {
                if (res.code == 1) {
                    this.$toast({
                        background: "#07c160",
                        message: this.$t('提交成功'),
                    });
                    this.step++
                    setTimeout(() => {
                        this.btnStatus = false
                        this.$router.replace('/idCard')
                    }, 2000)
                    return
                }
                this.$toast(res.info);
            });
        },
        backFun() {
            if (this.step > 1) {
                this.step--
                return
            } else {
                this.$router.back()
            }
        }
    }
};
</script>

<style scoped lang="scss">
/* 全局页面基础 */
.page-wrap {
    width: 100%;
    min-height: 100vh;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    font-family: system-ui, -apple-system, sans-serif;
}

/* 顶部返回栏 */
.header-back {
    display: flex;
    align-items: center;
    padding: 16px 14px;
    border-bottom: 1px solid #eeeeee;
    width: 100%;
    position: sticky;
    top: 0px;
    z-index: 999;
    background: #fff;
}

.back-icon {
    width: 20px;
    height: 20px;
}

.back-text {
    font-size: 16px;
    margin-left: 8px;
}

.back-btn {
    display: flex;
    align-items: center;
    width: fit-content;
}

/* 主内容区域 */
.main-content {
    flex: 1;
    padding: 24px 20px;
    overflow-y: auto;
}

.page-title {
    font-size: 22px;
    font-weight: bold;
    margin: 0 0 32px;
}

/* 实名认证标题行 */
.auth-title-row {
    display: flex;
    align-items: flex-start;
    margin-bottom: 10px;
    align-items: center;
}

.check-circle {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background-color: #DEDFE0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    flex-shrink: 0;
    color: #8A8D9A;
    font-size: 15px;
    font-weight: bold
}

.title-text-wrap .main-title {
    font-size: 16px;
    font-weight: 500;
}

.sub-desc {
    font-size: 14px;
    color: #333333;
    margin: 0 0 15px 0;
}

/* 表单容器 左侧竖线 */
.form-wrap {
    border-left: 2px dashed #dddddd;
    margin-left: 12px;
    padding-left: 20px;
    margin-bottom: 10px;
}

.form-item {
    margin-bottom: 24px;
    position: relative;
}

.form-label {
    display: block;
    font-size: 14px;
    color: #333;
    margin-bottom: 8px;
}

/* 下拉选择框样式 */
.select-box {
    width: 100%;
    height: 42px;
    border: 1px solid #dddddd;
    border-radius: 30px;
    display: flex;
    align-items: center;
    position: relative;
    box-sizing: border-box;
    background: #F3F3F5;
    font-size: 14px;
}
::v-deep .van-cell {
    background: none;
}
::v-deep .van-cell__title {
    color: #D3D5D6;
}

::v-deep .van-cell__value {
    color: #333;
}
.select-date ::v-deep .van-cell__value {
    color: #D3D5D6;
}
.select-prefix {
    color: #555;
    font-size: 16px;
}

.inner-select {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
}

.select-placeholder {
    color: #bbbbbb;
    font-size: 14px;
}

.select-text {
    color: #333;
}

.date-input {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 0;
    width: calc(100% - 32px);
    height: 100%;
    opacity: 0;
    z-index: 10;
    font-size: 14px;
}

.arrow-down {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
}

/* 输入框样式 */
.input-box {
    width: 100%;
    height: 42px;
    border: 1px solid #dddddd;
    border-radius: 30px;
    background: #F3F3F5;
    display: flex;
    align-items: center;
    padding: 0 10px 0 16px;
    box-sizing: border-box;
    position: relative;

    .text-phone {
        display: flex;
        padding: 0px;
        height: 100%;
        align-items: center;
        font-size: 14px;
        color: #333;
    }
}

.inner-input {
    flex: 1;
    border: none;
    outline: none;
    font-size: 14px;
}

.clear-btn {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background-color: #e8e8e8;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    flex-shrink: 0;
}

.close-icon {
    width: 10px;
    height: 10px;
}

/* 单选框组 */
.radio-group {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.radio-item {
    display: flex;
    align-items: center;
    font-size: 16px;

    .quan {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 1px solid #333;
        padding: 2px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 5px;

        .iconfont {
            display: none;
            font-size: 12px;
            font-weight: bold;
        }
    }

    .active {
        background: #000;

        .iconfont {
            display: block;
            color: #fff;
        }
    }

    span {
        font-size: 14px;
    }
}

.radio-input {
    width: 20px;
    height: 20px;
    margin-right: 8px;
}

/* 提示文字 */
.tip-text {
    color: #666666;
    font-size: 14px;
    line-height: 1.6;
}

.tip-text p {
    margin: 2px 0;
}

/* 按钮通用 */
.next-btn,
.submit-btn {
    width: 100%;
    height: 46px;
    border-radius: 30px;
    border: none;
    font-size: 14px;
    margin-top: 16px;
}

.btn-disabled {
    background-color: #f2f2f2;
    color: #bbbbbb;
    cursor: not-allowed;
}

.btn-active {
    background-color: #222222;
    color: #ffffff;
}

.btn-blue-active {
    background-color: #2563eb;
    color: #ffffff;
}

/* 步骤进度 */
.step-progress {
    border-left: 2px solid #eeeeee;
    margin-left: 14px;
    padding-left: 40px;
    margin-top: 40px;
}

.step-item {
    display: flex;
    align-items: center;
    margin-bottom: 32px;
}

.gray-step .step-num {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 1px solid #cccccc;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
    margin-right: 12px;
    flex-shrink: 0;
}

.step-text {
    font-size: 18px;
    color: #999;
}

/* 第二步：信息展示区域 */
.info-show-wrap {
    border-left: 2px dashed #dddddd;
    margin-left: 12px;
    margin-bottom: 10px;
    padding: 10px 0px 10px 20px;
}

.info-line {
    font-size: 16px;
    color: #777777;
    margin: 15px 0;
}

/* 第二步标题 */
.step-title-row {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.gray-step-num {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background-color: #DEDFE0;
    color: #898A8F;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    flex-shrink: 0;
    font-size: 14px;
    font-weight: bold;
}

.step-main-title {
    font-size: 16px;
    font-weight: 500;
    margin: 0;
}

/* 上传规则文字 */
.upload-rule-text {
    font-size: 16px;
    color: #666;
    line-height: 1.6;
    margin-bottom: 32px;
}

.upload-rule-text p {
    margin: 4px 0;
    font-size: 14px;
}

/* 上传卡片 */
.upload-card {
    margin-bottom: 32px;
}

.upload-label-row {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.upload-label {
    font-size: 16px;
    margin-right: 6px;
}

.tip-icon {
    width: 16px;
    height: 16px;
    color: #999;
}

.upload-box {
    width: 100%;
    height: 220px;
    border: 1px solid #dddddd;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;
    background: #F7F7FA;

}

::v-deep .van-uploader,
::v-deep .van-uploader__wrapper,
::v-deep .van-uploader__preview {
    width: 100%;
    height: 100%;
    margin: 0px;
}

::v-deep .van-uploader__wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
}

::v-deep .van-uploader__preview {
    display: flex;
    align-items: center;
    justify-content: center;
}

::v-deep .van-uploader__preview-delete {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
}

::v-deep .van-uploader__preview-delete-icon {
    font-size: 26px !important;
}

.file-input {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    opacity: 0;
    cursor: pointer;
}


.upload-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.upload-empty-icon {
    width: 48px;
    height: 48px;
    color: #dddddd;
}

.upload-blue-text {
    color: #2563eb;
    font-size: 16px;
    margin-top: 8px;
}

.img-preview-wrap {
    width: 100%;
    height: 100%;
    position: relative;
}

.preview-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.img-close {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 28px;
    height: 28px;
    background-color: #eeeeee;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.reupload-btn {
    width: 100%;
    height: 48px;
    border: 1px solid #dddddd;
    background: #fff;
    border-radius: 10px;
    margin-top: 12px;
    font-size: 16px;
    color: #666;
}

/* 底部tab栏 */
.tab-bar {
    display: flex;
    justify-content: space-around;
    padding: 12px 0;
    border-top: 1px solid #eeeeee;
    background: #fff;
}

.tab-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #aaaaaa;
}

.active-tab {
    color: #000000;
}

.tab-icon {
    width: 26px;
    height: 26px;
}

.tab-text {
    font-size: 13px;
    margin-top: 4px;
}

/* 滚动条美化 */
::-webkit-scrollbar {
    width: 4px;
}

::-webkit-scrollbar-thumb {
    background: #ddd;
    border-radius: 2px;
}

.item_box {
    width: 100%;
    height: 320px;
    overflow-y: scroll;
    position: absolute;
    left: 0px;
    top: 72px;
    background: #fff;
    box-shadow: 0 0 3px #999;
    border-radius: 10px;
    padding: 10px 10px 0px 10px;
    z-index: 10;

    .search-box {
        height: 40px;
        width: 100%;
        background: #eee;
        border-radius: 8px;
        margin-bottom: 10px;
        padding: 0 10px;
        box-sizing: border-box;

        input {
            width: 100%;
            height: 100%;
            font-size: 14px;
        }
    }

    a {
        display: block;
        width: 100%;
        height: 38px;
        border-bottom: 1px solid #eee;
        line-height: 38px;
        padding: 0 8px;
    }

    .active {
        background: #eee;
    }
}
</style>